import { Brightness6Icon } from './Brightness6Icon';

/**
 * author: Google
 * id 34818392-81EE-4210-8F86-9C448596C912
 * name brightness-6
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/brightness-6.svg
 * tags
 */
export const BrightnessMediumIcon = Brightness6Icon;
export default BrightnessMediumIcon